/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Withdiscountsitemdesc3Inputs */

const id_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat game yang sedang diskon besar-besaran.`)
};

const ms_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat permainan yang sedang dijual dengan diskaun hebat.`)
};

const da_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se spil der er på tilbud med store rabatter.`)
};

const de_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehen Sie sich Spiele an, die gerade mit tollen Rabatten im Angebot sind.`)
};

const en_us2_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check out games currently on sale with great discounts.`)
};

const es_es2_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubre juegos actualmente con descuento.`)
};

const es_mx2_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubre juegos actualmente con grandes descuentos.`)
};

const fil_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan ang mga larong kasalukuyang naka-sale na may magagandang diskwento.`)
};

const fr_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez les jeux actuellement en promotion avec de bonnes réductions.`)
};

const it_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri i giochi attualmente in offerta con grandi sconti.`)
};

const hu_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nézd meg az aktuálisan akciós játékokat nagyszerű kedvezményekkel.`)
};

const nl_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk games die momenteel in de aanbieding zijn met grote kortingen.`)
};

const no_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjekk ut spill som er på salg med gode rabatter.`)
};

const pl_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź gry aktualnie objęte promocjami.`)
};

const pt_br2_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confira jogos com desconto no momento.`)
};

const pt_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja jogos atualmente com descontos imperdíveis.`)
};

const ro_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi jocurile aflate acum la reducere.`)
};

const fi_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katso parhaillaan alennuksessa olevia pelejä.`)
};

const sv_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolla in spel som för närvarande har bra rabatter.`)
};

const vi_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem các game đang được giảm giá hấp dẫn.`)
};

const tr_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Büyük indirimlerle satışta olan oyunlara göz atın.`)
};

const cs_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podívejte se na hry aktuálně ve slevě.`)
};

const bg_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вижте игрите, които в момента са на промоция с големи отстъпки.`)
};

const ru_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотрите игры, на которые сейчас действуют отличные скидки.`)
};

const uk_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перегляньте ігри з великими знижками.`)
};

const ar_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفح الألعاب المخفضة حاليًا بخصومات رائعة.`)
};

const hi_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बड़ी छूट वाले गेम देखें।`)
};

const th_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูเกมที่ลดราคาพร้อมส่วนลดดี ๆ`)
};

const ja_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お得な割引が適用されているゲームをチェック。`)
};

const zh_cn2_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看当前正在促销的折扣游戏。`)
};

const zh_hant1_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檢視目前正在促銷的折扣遊戲。`)
};

const ko_nav_withdiscountsitemdesc3 = /** @type {(inputs: Nav_Withdiscountsitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 할인 중인 게임을 확인하세요.`)
};

/**
* | output |
* | --- |
* | "Check out games currently on sale with great discounts." |
*
* @param {Nav_Withdiscountsitemdesc3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_withdiscountsitemdesc3 = /** @type {((inputs?: Nav_Withdiscountsitemdesc3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Withdiscountsitemdesc3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_withdiscountsitemdesc3(inputs)
	if (locale === "ms") return ms_nav_withdiscountsitemdesc3(inputs)
	if (locale === "da") return da_nav_withdiscountsitemdesc3(inputs)
	if (locale === "de") return de_nav_withdiscountsitemdesc3(inputs)
	if (locale === "en-US") return en_us2_nav_withdiscountsitemdesc3(inputs)
	if (locale === "es-ES") return es_es2_nav_withdiscountsitemdesc3(inputs)
	if (locale === "es-MX") return es_mx2_nav_withdiscountsitemdesc3(inputs)
	if (locale === "fil") return fil_nav_withdiscountsitemdesc3(inputs)
	if (locale === "fr") return fr_nav_withdiscountsitemdesc3(inputs)
	if (locale === "it") return it_nav_withdiscountsitemdesc3(inputs)
	if (locale === "hu") return hu_nav_withdiscountsitemdesc3(inputs)
	if (locale === "nl") return nl_nav_withdiscountsitemdesc3(inputs)
	if (locale === "no") return no_nav_withdiscountsitemdesc3(inputs)
	if (locale === "pl") return pl_nav_withdiscountsitemdesc3(inputs)
	if (locale === "pt-BR") return pt_br2_nav_withdiscountsitemdesc3(inputs)
	if (locale === "pt") return pt_nav_withdiscountsitemdesc3(inputs)
	if (locale === "ro") return ro_nav_withdiscountsitemdesc3(inputs)
	if (locale === "fi") return fi_nav_withdiscountsitemdesc3(inputs)
	if (locale === "sv") return sv_nav_withdiscountsitemdesc3(inputs)
	if (locale === "vi") return vi_nav_withdiscountsitemdesc3(inputs)
	if (locale === "tr") return tr_nav_withdiscountsitemdesc3(inputs)
	if (locale === "cs") return cs_nav_withdiscountsitemdesc3(inputs)
	if (locale === "bg") return bg_nav_withdiscountsitemdesc3(inputs)
	if (locale === "ru") return ru_nav_withdiscountsitemdesc3(inputs)
	if (locale === "uk") return uk_nav_withdiscountsitemdesc3(inputs)
	if (locale === "ar") return ar_nav_withdiscountsitemdesc3(inputs)
	if (locale === "hi") return hi_nav_withdiscountsitemdesc3(inputs)
	if (locale === "th") return th_nav_withdiscountsitemdesc3(inputs)
	if (locale === "ja") return ja_nav_withdiscountsitemdesc3(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_withdiscountsitemdesc3(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_withdiscountsitemdesc3(inputs)
	return ko_nav_withdiscountsitemdesc3(inputs)
});
export { nav_withdiscountsitemdesc3 as "nav.withDiscountsItemDesc" }